<template>
  <o-view>
    <o-nav-bar title="Favorieten" :has-back-button="true" />
    <o-block-list title="Routes">
      <o-list-item label="Favoriet 1" icon="train" />
      <o-list-item label="Favoriet 2" icon="train" />
      <o-list-item label="Favoriet 3" icon="train" />
    </o-block-list>
    <o-block-list title="Plaatsen">
      <o-list-item
        label="Favoriet 1"
        icon="brands/bluebike"
        icon-style="logo"
      />
      <o-list-item label="Favoriet 2" icon="brands/velo" icon-style="logo" />
      <o-list-item label="Favoriet 3" icon="brands/velo" icon-style="logo" />
    </o-block-list>
  </o-view>
</template>

<script>
export default {
  name: 'Favorites',
  data() {
    return {
      products: [
        {
          label: 'De Lijn',
          icon: 'brands/delijn',
          keepColors: true
        },
        {
          label: 'Antwerpen - Gent',
          icon: 'brands/nmbs',
          keepColors: true
        },
        {
          label: 'Antwerpen - Brussel',
          icon: 'brands/nmbs',
          keepColors: true
        },
        {
          label: 'Blue-bike Gent-Dampoort',
          icon: 'brands/bluebike',
          keepColors: true
        },
        {
          label: 'Velo Antwerpen-Centraal',
          icon: 'brands/velo',
          keepColors: true
        },
        {
          label: 'Velo Turnhoutsebaan',
          icon: 'brands/velo',
          keepColors: true
        }
      ]
    }
  }
}
</script>

<style lang="scss">
.c-favorites {
  background: $primary-color;
  background: var(--primary-color);
  color: #fff;
  position: relative;
  z-index: 20;
}
</style>
